import { Badge, withStyles } from '@material-ui/core'

export const StyledBadge = withStyles(() => ({
  badge: {
    right: 17,
    top: '50%',
  },
}))(Badge)
